module.exports = __webpack_public_path__ + "assets/lucky-wheel-button-15cc9c.png";